import React, { useState, useEffect, useRef } from 'react'

import { Box, Typography } from '@mui/material'
import './styles.css'
import GraphToolbar from '../default-toolbar'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { graph_theme, convert_time, defaultNames } from '../default-toolbar'

import LoadingButton from '@mui/lab/LoadingButton';

import { exportHtmlToImage } from "../../../../../utils/exportHtmlToImage";

import ExportIcon from '@mui/icons-material/Download';

import BarChart from "../../../../D3/BarChart";

const columns = graph => {
  const columns = []
  if (graph !== 'general')
    columns.push({ field: 'group', headerName: 'Agrupamento', flex: 1 })
  columns.push({
    field: 'tag',
    headerName: 'Tag',
    flex: 1,
  })
  columns.push({
    field: 'count',
    headerName: 'Quantidade',
    flex: .5
  })
  return columns
}

const Retention = ({ data, option, periodText }) => {

  const [parsedData, setParsedData] = useState([])

  const containerRef = useRef(null)

  const getAggregatedData = (data) => {
    if (data.rows && data.rows.length > 0) {
      if (option === 'general') {
        const aggregatedData = data.rows.map(row => ({ label: row.tag, value: row.count }));
        return aggregatedData;

      } else {
        const aggregatedData = {}
        data.rows.forEach(({ group, tag, count }) => {
          if (!aggregatedData[tag])
            aggregatedData[tag] = 0;
          aggregatedData[tag] += count;
        });

        return Object.entries(aggregatedData).map((k, v) => {
          return { label: k[0], value: k[1] }
        }); 

      }
    }
    return [];
  }

  useEffect(() => {
    setParsedData(getAggregatedData(data))
  }, [data])

  return (
    <Box className='graph-main-divisor'>
      <Box className='graph-main-table'>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={graph_theme}>
            <DataGridPro
              density='compact'
              columns={columns(option)}
              rows={data?.rows.map((r, index) => ({ ...r, id: index + 1 }))}
              hideFooter={true}
              components={{
                Toolbar: GraphToolbar
              }}
            />
          </ThemeProvider>
        </StyledEngineProvider>
      </Box>
      <Box className='graph-main-dashboards'>
        <Box className='graph-time-rows'>
          {data.rows?.length !== 0 &&
            <>
              <Box sx={{ position: 'absolute', right: '0' }}>
                <LoadingButton startIcon={<ExportIcon />}
                  sx={{ position: 'absolute', right: '2rem', top: '0rem', zIndex: 1 }}
                  onClick={() => exportHtmlToImage(containerRef.current)}
                >
                  Exportar
                </LoadingButton>
              </Box>
              <Box className='new-graphs-wrapper'>
                <div ref={containerRef} style={{ width: "100%", height: "100%", padding: "1rem", position: 'relative' }}>
                <img style={{ width: '10rem', display: 'none', position: 'absolute', right: 0 }} src="/static/media/kwik_color.f6459d28.png" alt="logo" class="logo" id="logo" className='showcopyright'></img>
                  <Typography variant="subtitle1">Retenção por tags.</Typography>
                  <BarChart data={parsedData} />
                  <Typography sx={{ display: 'none', position: 'absolute', bottom: 0 }} variant="body2" align="center" className='showcopyright'>
                    Copyright (c) {new Date().getFullYear()} - Instant Solutions Tecnologia e Informática Ltda.
                  </Typography>
                </div>
              </Box>
            </>
          }
        </Box>
      </Box>
    </Box>
  )
}

export default Retention
